import React from 'react';
import styles from './logins.module.css';
import { FluxButton } from '@meltwater/flux-web-components-react';

function LogoutButton(props) {
  const handleLogout = () => {
    // Clear app auth state
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('jwtExpiration');
    
    if (props.onClick) {
      props.onClick();
    }

    if (props.preventNavigation === true) {
      return;
    }

    window.location.href = props.href || "/";
  };
  
  return (
    <FluxButton 
      onClick={handleLogout} 
      startIcon={props.startIcon}
      tint="default" 
      type="plain"
      className={`${styles.menuLogoutButton} ${props.className || ''}`}
    >
      {props.children || "Logout"}
    </FluxButton>
  );
}

export default LogoutButton;
